import { TabsProps } from "antd"

import variables from "@/_styles/variables.module.scss"

import { ICustomer, IDispatcherCustomer } from "./ICustomer"
import { IDelivery } from "./IDelivery"
import { IDeliveryAddress } from "./IDeliveryAddress"
import { IDepot } from "./IDepot"
import { IDriver } from "./IDriver"
import { ITransport } from "./ITransport"


export interface IOrder {
  id: number
  number: string
  date: string
  status: number
  statusText: string
  deliveryType: number
  deliveryTypeText: string
  delivery: IDelivery
  exchangeType?: number
  exchangeTypeText?: string
  deliveryPrice: number
  orderSumm: number
  orderAmount: number
  paymentSumm: number
  paymentStatus: number
  paymentStatusText: string
  isReserve: boolean
  wishTimeSlot?: string
  isTimeAgreed?: boolean
  isBackdating?: boolean
  isPriceSet: boolean
  customer: ICustomer
  customerCategoryId: number
  depot: IDepot
  depotId: number
  fuelTypeId?: number
  fuelQuoteOrdersFuelTypes?: string[]
  fuelFutureOrdersFuelTypes?: string[]
  fuelBackdatingOrdersFuelTypes?: string[]
  transports: ITranportPairOrder[]
  fuelQuotes: IOrderFuel[]
  operationType: number
  operationTypeText: string
  createdOn: Date,
  actualLoadTime: Date,
  arrivalTime?: Date,
  departureTime?: Date
  redFlagType?: number
}

export interface IDispatcherOrder {
  id: number
  number: string
  date: string
  status: number
  statusText: string
  deliveryType: number
  deliveryTypeText: string
  delivery: IDelivery
  exchangeType?: number
  exchangeTypeText?: string
  orderAmount: number
  paymentStatus: number
  paymentStatusText: string
  wishTimeSlot?: string
  isTimeAgreed?: boolean
  customer: IDispatcherCustomer
  depot: IDepot
  depotId: number
  fuelQuoteOrdersFuelTypes?: string[]
  fuelFutureOrdersFuelTypes?: string[]
  fuelBackdatingOrdersFuelTypes?: string[]
  transports: ITranportPairOrder[]
  fuelQuotes: IDispatcherOrderFuel[]
  createdOn: Date,
  actualLoadTime?: Date,
  arrivalTime?: Date,
  departureTime?: Date
}

export interface IOrderFuel {
  id: number
  quoteId: number
  fuelTypeId: number
  fuelType: string
  density: number
  price: number,
  addon: number,
  amount: number
  isFuture: boolean,
  limitId?: number,
  limitSettingId: number
}

export interface IFuelBackDatingQuoteOrder {
  date: Date
  sellingPrice: number
  density: number
  fuelId: number,
  amount: number
}

export interface IDispatcherOrderFuel {
  id: number
  quoteId: number
  fuelType: string
  density: number
  amount: number
  isFuture: boolean,
  limitId?: number,
  limitSettingId?: number
}

export interface IWaybillFuel extends IDispatcherOrderFuel {
  section: number | undefined
  temperature: number | undefined
  qualityPassport: string
}

export interface ITranportPairOrder {
  id: number
  driverId: number
  driver?: IDriver
  truckId: number
  truck?: ITransport
  pickupId?: number
  pickup?: ITransport
  wishTimeSlot?: string
  fuelAmount: number
}

export interface IOrderCreate {
  date: Date | string
  deliveryType: DeliveryType
  isBackdating?:boolean
  backdatingStatus?: OrderStatus
  delivery: IDeliveryOrderCreate
  exchangeType?: ExchangeType
  customerId: number
  depotId: number
  deliveryPrice: number
  wishTimeSlot?: string
  isReserve: boolean
  transports: ITranportPairOrderCreate[]
  fuelQuoteOrders: IFuelQuoteOrder[]
  fuelBackdatingQuoteOrder?: IFuelBackDatingQuoteOrder[]
  fuelFutureOrders: IFuelFutureOrder[]
  newAddresses?: IDeliveryAddress[]
  newDrivers?: IDriver[]
  newTransports?: ITransport[]
}

export interface IOrderRecreate extends IOrderCreate {
  id: number
}

export interface IOrderUpdate extends IOrderCreate {
  id: number,
  consistChanged: boolean
}

export interface IDeliveryOrderCreate {
  deliveryAddressId: number
  pump?: boolean
  commentary?: string
}

export interface ITranportPairOrderCreate {
  driverId: number
  truckId: number
  fuelAmount: number
  pickupId?: number
  wishTimeSlot?: string
}

export interface IFuelQuoteOrder {
  id: number
  amount: number,
  limitId?: number | null,
  limitSettingId?: number | null
}

export interface IFuelFutureOrder {
  id: number
  amount: number,
  avgPrice: number,
  addon: number,
  limitId?: number | null
  limitSettingId?: number | null
}

export interface IOrderChangeStatus {
  orderId: number
  orderStatus: OrderStatus
}

export interface IOrderApprove {
  orderId: number
  isApproved: boolean
}

export interface IOrderPayForOrder {
  orderId: number
  withPayment: boolean
}

export interface IOrderShip {
  orderId: number
  arrivalTime: Date
  loadTime: Date
  departureTime: Date
}

export interface IOrderCoordinateTime {
  orderId: number
  isTimeAgreed?: boolean
  newSlot?: string
}

export interface IOrderLogDescription {
  changesType: OrderChangeType
  changesTypeText: string
  prevText: string
  currentText: string
}

export interface IOrderLog{
  id: number
  modifiedBy: string
  modifiedByName?: string
  modifiedOn: Date
  orderId: number
  changesTypes: OrderChangeType[]
  currentValue: string
  prevValue?: string
  event: OrderLogEvent
  eventText: string
  descriptions: IOrderLogDescription[]
}

export interface IOrderChangeRedFlag {
  orderId: number
  orderFlagType: RedFlagType
}

export enum DeliveryType {
  Delivery,
  Pickup,
  All
}

export const deliveryTypes = [
  {
    name: "Доставка",
    type: DeliveryType.Delivery
  },
  {
    name: "Самовывоз",
    type: DeliveryType.Pickup
  }
]

export enum ExchangeType {
  Electronic,
  Paper
}

export const exchangeTypes = [
  {
    name: "Электронная",
    type: ExchangeType.Electronic
  },
  {
    name: "Бумажная",
    type: ExchangeType.Paper
  }
]

export enum OrderStatus {
  New,                          // Создан
  OnApproval,                   // В обработке
  WaitingForPayment,            // Ожидает оплаты
  IsReserve,                    // Зарезервировано
  DispatcherTimeCoordination,   // Согласование времени
  TimeIsSet,                    // Время согласовано
  Approved,                     // Подтвержден
  OnLoading,                    // На загрузке
  Shipped,                      // Отгружен
  Canceled,                     // Аннулирован
  Closed,                       // Выполнен
  ClientTimeCoordination,       // Согласование времени клиентом
  OnClientApprovingTransport,   // На уточнении ТС у клиента
  Placed,                       // Размещен
  NotSettedTime,                // Время не согласовано
  OnApprovalDelivery            // В обработке доставки
}

export enum OrderAction {
  Approve,
  PayForOrder,
  FinanceDownload,
  DispatcherTimeCoordination,
  OnApprovalDelivery,
  OnLoad,
  Ship,
  Cancel,
  Close,
  Place,
  Reload,
  EditByCustomer, // редактирует водителя, транспорт, объем топлива
  Edit,
  ApproveTransport,
  ClientTimeCoordination,
  FillTTN,
  EditTTN,
  DownloadTTN,
  BackToApproved,
  Reserve,
  Unreserve
}

export enum OrderChangeType{
  ChangeStatus,
  ChangeDeliveryType,
  ChangeDelivery,
  ChangeExchangeType,
  ChangeDeliveryPrice,
  ChangeDepot,
  ChangePaymentSumm,
  ChangePaymentStatus,
  ChangeOrderSumm,
  ChangeOrderAmount,
  ChangePeriodTime,
  ChangeTime,
  ChangeTransport,
  ChangeFuelQoute,
  ChangeFuelFuture
}

export enum OrderPaymentStatus {
  NotPaid,
  ReservePaid,
  Paid
}

export enum OrderLogEvent {
  Created = 0,
  Updated = 1,
  Deleted = 2,
  CancelledByDateInspector = 3,
  Approved = 4,
  ChangedStatus = 5,
  TimeApproved = 6,
  Paid = 7,
  ReservePaid = 8,
  FuelPriceSet = 9,
  Cancelled = 10,
  TransportUpdated = 11,
  AuthoritiesSoapUpdated = 12,
  MovedToNextDayByDateInspector = 13,
  InternalLog = 14, //не для клиентской части
  RequiresManualProcessing = 15,
  SetReserved = 16,
  CreateWaybill = 17,
  UpdateWaybill = 18
}

export enum OrderStatusTabKeys {
  All = "All",
  OnApproval = "OnApproval",
  WaitingForPayment = "WaitingForPayment",
  Approved = "Approved",
  Shipped = "Shipped",
  Canceled = "Canceled"
}

export enum RedFlagType
{
    /// <summary>
    /// при переносе заказа (на загрузке) в новую дату не нашлось подходящего лимита
    /// отправлен на ручную обработку
    /// </summary>
    NoVacantFuelLimitsForNewDate
}


export const OrderStatusTabs: TabsProps["items"] = [
  {
    key: OrderStatusTabKeys.All,
    label: "Все"
  },
  {
    key: OrderStatusTabKeys.OnApproval,
    label: "Ожидают подтверждения"
  },
  {
    key: OrderStatusTabKeys.WaitingForPayment,
    label: "Ожидают оплаты"
  },
  {
    key: OrderStatusTabKeys.Approved,
    label: "Ожидают отгрузки"
  },
  {
    key: OrderStatusTabKeys.Shipped,
    label: "Отгруженные"
  },
  {
    key: OrderStatusTabKeys.Canceled,
    label: "Отменены"
  }
]

export const DispatcherOrderStatusTabs: TabsProps["items"] = [
  {
    key: OrderStatusTabKeys.All,
    label: "Все"
  },
  {
    key: OrderStatusTabKeys.Approved,
    label: "Ожидают отгрузки"
  },
  {
    key: OrderStatusTabKeys.Shipped,
    label: "Отгруженные"
  }
]

export const OrderStatusColors: Record<number, string> = {
  0: variables.statusBlueColor,     // Создан
  1: variables.statusOrangeColor,   // В обработке
  2: variables.statusOrangeColor,   // Ожидает оплаты
  3: variables.statusBlueColor,     // Зарезервировано
  4: variables.statusOrangeColor,   // Согласование времени
  5: variables.statusVioletColor,   // Время согласовано
  6: variables.statusVioletColor,   // Подтвержден
  7: variables.statusBlueColor,     // На загрузке
  8: variables.statusGreenColor,    // Отгружен
  9: variables.statusRedColor,      // Аннулирован
  10: variables.statusGreenColor,   // Выполнен
  11: variables.statusOrangeColor,  // Согласование времени клиентом
  12: variables.statusOrangeColor,  // На уточнении ТС у клиента
  13: variables.statusBlueColor,    // Размещен
  14: variables.statusRedColor,     // Время не согласовано
  15: variables.statusOrangeColor   // В обработке доставки
}

export const ORDERS_KEY = "ORDERS_KEY"
export const ORDERS_HISTORY_KEY = "ORDERS_HISTORY_KEY"
export const ORDERS_DISPATCHER_KEY = "ORDERS_DISPATCHER_KEY"
export const ORDERS_DISPATCHER_TIME_COORDINATE_KEY = "ORDERS_DISPATCHER_TIME_COORDINATE_KEY"

export const activeOrdersFilter = `Status != ${OrderStatus.Closed}, Status != ${OrderStatus.Canceled}`